import { atom, selector } from 'recoil';
import { getWithExpiry } from 'Helpers/getset-with-expiry';
import { isEmpty } from 'lodash';

type Status = 'idle' | 'loading' | 'success' | 'error';

export interface AuthActionStatusAtom {
  login: Status;
  forgetPassword: Status;
  resetPassword: Status;
  resendVerifyEmail: Status | 'after_success';
  verifyEmail: Status;
  logout: Status;
  register: Status;
}

export const authActionStatusAtom = atom<AuthActionStatusAtom>({
  key: 'authActionStatusAtom',
  default: {
    login: 'idle',
    forgetPassword: 'idle',
    resetPassword: 'idle',
    resendVerifyEmail: 'idle',
    verifyEmail: 'idle',
    logout: 'idle',
    register: 'idle',
  }
});

const session = getWithExpiry(process.env.APP_SESSION);

export const isAuthAtom = atom({
  key: 'isAuthAtom',
  default: !isEmpty(session)
})

export const authPassportAtom = atom({
  key: 'authPassportAtom',
  default: session ? session : {}
})

export const authErrorAtom = atom({
  key: 'authErrorAtom',
  default: {}
})



